import { l10n } from '@ott/l10n';
import * as yup from 'yup';

export const getMonthValidation = () => {
  return yup
    .string()
    .required(l10n('required.required'))
    .test((month, { createError, path }) => {
      const monthValue = Number(month);

      if (monthValue >= 1 && monthValue <= 12) {
        return true;
      }

      return createError({
        message: l10n('wrong.cardMonth'),
        path,
      });
    });
};
